import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { 
  Car, 
  ArrowLeft, 
  ExternalLink,
  Monitor,
  Maximize2,
  Minimize2
} from "lucide-react";
import { Button } from "@/components/ui/button";

export default function TestsExternPage() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  return (
    <div className={`min-h-screen bg-slate-100 ${isFullscreen ? 'fixed inset-0 z-50' : ''}`} data-testid="tests-extern-page">
      {/* Header */}
      {!isFullscreen && (
        <div className="bg-white border-b border-slate-200 sticky top-0 z-10">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <Link to="/dashboard" className="text-slate-500 hover:text-slate-700">
                  <ArrowLeft className="w-5 h-5" />
                </Link>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center">
                    <Car className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h1 className="font-bold text-slate-900">Teste DRPCIV</h1>
                    <p className="text-sm text-slate-500">Chestionare oficiale</p>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={toggleFullscreen}
                  className="flex items-center gap-2"
                >
                  <Maximize2 className="w-4 h-4" />
                  Ecran complet
                </Button>
                <a 
                  href="https://chestionareauto.ro" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-slate-500 hover:text-blue-600 flex items-center gap-1"
                >
                  <ExternalLink className="w-4 h-4" />
                  Deschide în tab nou
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Fullscreen close button */}
      {isFullscreen && (
        <Button
          variant="secondary"
          size="sm"
          onClick={toggleFullscreen}
          className="fixed top-4 right-4 z-50 shadow-lg"
        >
          <Minimize2 className="w-4 h-4 mr-2" />
          Ieși din ecran complet
        </Button>
      )}

      {/* Iframe Container */}
      <div className={`${isFullscreen ? 'h-screen' : 'max-w-7xl mx-auto px-4 py-6'}`}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className={`bg-white rounded-xl shadow-lg overflow-hidden ${isFullscreen ? 'h-full' : ''}`}
        >
          <iframe
            src="https://chestionareauto.ro/api/chestionar"
            title="Chestionare Auto DRPCIV"
            className={`w-full border-0 ${isFullscreen ? 'h-full' : 'h-[800px]'}`}
            allow="fullscreen"
            loading="lazy"
          />
        </motion.div>

        {/* Info Box */}
        {!isFullscreen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="mt-6 bg-blue-50 border border-blue-200 rounded-xl p-4"
          >
            <div className="flex items-start gap-3">
              <Monitor className="w-5 h-5 text-blue-600 mt-0.5" />
              <div>
                <h3 className="font-semibold text-blue-900">Teste oficiale DRPCIV</h3>
                <p className="text-sm text-blue-700 mt-1">
                  Acestea sunt chestionarele oficiale folosite la examenul auto. 
                  Selectează categoria dorită și începe testul.
                </p>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
